import React from 'react'
import './StartChatComponent.css'
import {useEffect, useContext, useState} from 'react'
import UserContext from '../../context/UserContext';

function StartChatComponent() {


  const [yourName, setyourName] = useState("");
  const [yourEmail, setyourEmail] = useState("");
  const [yourMessage, setyourMessage] = useState("");
  const [offlineMessageSent, setofflineMessageSent] = useState(false);
  

  const [emailError, setemailError] = useState(false);
  const [messageError, setmessageError] = useState(false);

  const appContext = useContext(UserContext)
  const textInWidgetChatNotStarted = appContext.myStrings.textInWidgetChatNotStarted
  const textInWidgetChatNotStartedOnline = appContext.myStrings.textInWidgetChatNotStartedOnline
  const owner_online = appContext.owner_online
  const displayMessageOnSuccess = appContext.myStrings.thankYouTextAfterMessage
  const customerData = appContext.customerData

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  //------------------------

  const sendChatStartGreetingToAgent = () =>{

    const customerCookie = appContext.getCookie('customer_id_ex');
    const owner_token = appContext.owner_token

    // sending that the chat is starting
    const payload = {name: yourName, email: yourEmail, customer_id: customerCookie, owner_token: owner_token}
    const obj1 = {action: "chat_starting", payload: payload}

    //-------

    appContext.socket.send(JSON.stringify(obj1));

  }

  //-----------------------


  const leaveAMessageFunction = async () =>{

    let sendok = true;
    const owner_token = appContext.owner_token
    const customerCookie = appContext.getCookie('customer_id_ex');

    if(!isValidEmail(yourEmail))
    {
        // email isnt valid
        setemailError(true)
        sendok = false;
    }


    if(yourMessage.length < 10)
          {
            setmessageError(true)
              sendok = false;
          }

     
          if(sendok == true)
          {

    const url = 'https://api10.easychatdesk.com/send-offline-ticket';
    try {
      const response = await fetch( url , { // Replace with your actual API URL
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            owner_token:  owner_token,
            customer_id: customerCookie,
            email: yourEmail,
            message: yourMessage,
            country: "",
            region: "",
            city: "",
            name: yourName,
            currentPageUrl: customerData.currentPageUrl

          })
      });

      if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
      } 

      const data = await response.json();


    setofflineMessageSent(true)

    }


    catch (error) {
      console.log(error.message);
  }
}
  }

  //-----------------------

  const startTheChat = () =>{

      if(yourEmail.length > 0)
      {
          if(!isValidEmail(yourEmail))
          {
              // email isnt valid
              setemailError(true)
          }
          else
          {
              //proceed to chat
              localStorage.setItem("yourName",  yourName)
              localStorage.setItem("yourEmail",  yourEmail)

              appContext.setChatStarted()
              sendChatStartGreetingToAgent()
          }
      } 
      else
      {
          // proceed to chat
          localStorage.setItem("yourName",  yourName)
          localStorage.setItem("yourEmail",  yourEmail)

          appContext.setChatStarted()
          sendChatStartGreetingToAgent()

      }

  }


  useEffect(() =>{

    const emailTmp = localStorage.getItem("yourEmail")
    const nameTmp = localStorage.getItem("yourName")

    if(emailTmp != undefined)
    {
      setyourEmail(emailTmp)
    }


    if(nameTmp != undefined)
    {
        setyourName(nameTmp)
    }



  }, [])



  const handleChange = (e) => {

    setyourName(e.target.value)
  }


  const handleChange2 = (e) => {

    setyourEmail(e.target.value)
  }


  const handleChange3 = (e) => {

    setyourMessage(e.target.value)
  }

  const closeChatOfflineWindow = () =>{

    window.parent.postMessage({ action: 'minimizeFullChatWidget', newStyle: '' }, '*');

  }

  if(offlineMessageSent == true)
  {
      return(<div className='ecd-start-chat-component' style={{padding:25}}>
        <p>{displayMessageOnSuccess}</p>

        <div className='ecd-mt-4'>
                  <button className='ecd-button-wrap' onClick={closeChatOfflineWindow}>Close chat window</button>
              </div>
      </div>)
  }  

  else if(owner_online == false)
  {


    return (




      <div className='ecd-start-chat-component' style={{paddingLeft:35, paddingTop:15, paddingRight:35}}>
  
              <p className="ecd-start-component-p">{textInWidgetChatNotStarted}</p>
  
  
              <div className='ecd-mb-2'>
                  <label className='ecd-mb-1'>Your name:</label>
                  <input type="text" className='ecd-text-field' value={yourName}  onChange={handleChange}  />
              </div>
  
  
              <div className='ecd-mb-2'>
                  <label className='ecd-mb-1'>Your e-mail address:</label>
                  <input type="text" className='ecd-text-field' value={yourEmail}  style={{borderColor: emailError==true ? "red" : "", borderWidth: emailError==true ? "2" : "" }}   onChange={handleChange2}  />
  
                  {
                    emailError == true ?
                
                    <span style={{fontSize: 11, color: "red"}}>Please provide a valid email address</span>
  
                    : null }
  
              </div>


              <div className='ecd-mb-2'>
                  <label className='ecd-mb-1'>Your message:</label>
                  <textarea type="text" className='ecd-text-field'  style={{borderColor: messageError==true ? "red" : "", borderWidth: emailError==true ? "2" : "" }}   onChange={handleChange3}>{yourMessage}</textarea>
                  {
                    messageError == true ?
                
                    <span style={{fontSize: 11, color: "red"}}>Please write a longer text message</span>
  
                    : null }
  
              </div>
  
  
              <div className='ecd-mt-4'>
                  <button className='ecd-button-wrap' onClick={leaveAMessageFunction}>{appContext.myStrings.leaveMessage}</button>
              </div>
  
      </div>
    )


  }
  else
  {
 
  return (


    <div className='ecd-start-chat-component'  style={{paddingLeft:35, paddingRight:35}}>

            <p className="ecd-start-component-p">{textInWidgetChatNotStartedOnline}</p>


            <div className='ecd-mb-3'>
                <label className='ecd-mb-1'>Your name:</label>
                <input type="text" className='ecd-text-field' value={yourName}  onChange={handleChange}  />
            </div>


            <div className='ecd-mb-3'>
                <label className='ecd-mb-1'>Your e-mail address:</label>
                <input type="text" className='ecd-text-field' value={yourEmail}  style={{borderColor: emailError==true ? "red" : "", borderWidth: emailError==true ? "2" : "" }}   onChange={handleChange2}  />

                {
                  emailError == true ?
              
                  <span style={{fontSize: 11, color: "red"}}>Please provide a valid email address</span>

                  : null }

            </div>


            <div className='ecd-mt-4'>
                <button className='ecd-button-wrap' onClick={startTheChat}>Start the chat</button>
            </div>

    </div>
  )

                }
}

export default StartChatComponent